<template>
  <form @submit.prevent="handleSubmit(item)">
    <b-row>
      <b-col>
        <div class="form-group">
          <label
                  for="excmteamuserdata_userData"
                  class="form-control-label">{{$t('views.excmteamuserdata.form.userData')}}:</label>
          <div class="form-group">
            <base-select-input
              v-model="item.userData"
              :search-callback="userDataSearchCallback"
              :query-param="'userdata'"
              :display-values="['fullName']"
              :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
            ></base-select-input>
          </div>
          <div
                  v-if="isInvalid('userData')"
                  class="invalid-feedback">{{ violations.userData }}</div>
        </div>
      </b-col>
    </b-row>

    <button type="submit" class="btn btn-primary">{{ $t('buttons.submit') }}</button>
    <b-btn @click="closeModal()" variant="danger">{{ $t('buttons.cancel') }}</b-btn>
  </form>
</template>

<script>
import ApiService from '@/utils/ApiService'
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput'

export default {
  components: { BaseSelectInput },
  props: {
    team: {
      type: Object,
      default: null
    },

    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      servicemenOptions: []
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  created () {
    if (this.team) {
      this.item.team = this.team['@id']
    }
  },

  methods: {
    closeModal () {
      this.$store.state.modals.excmteamuserdata.create.close = 1
    },

    async userDataSearchCallback (params = {}) {
      let baseParams = {
        pagination: false,
        isCompany: 0,
        state: 1,
        idClientType: 5
      }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    },

    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
